import { UpdateAddressResponse } from '@/types/address'
import { api } from './api'

interface UpdateAddressParams {
  id: number
  street: string
  streetNr: string
  postalCode: string
  city: string
  country: string
}

export const updateAddress = ({
  id,
  street,
  streetNr,
  postalCode,
  city,
  country,
}: UpdateAddressParams): Promise<UpdateAddressResponse> => {
  return api.put(`/address/${id}`, {
    street,
    streetNr,
    postalCode,
    city,
    country,
  })
}
